/* A component that is used to preview a form. */
import React, { Component } from "react"
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap"
import DynamicForm from "../DynamicForm"
import DynamicFormTypes from "../../Types/DynamicFormsTypes"
import stateMutator from "../../Utils/StateMutator"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import paletteEngine from "../../Utils/paletteEngine"
import TrashCan from "../../Utils/TrashCan/TrashCan"
import dynamicFormTootip from "../../Utils/DynamicFormTooltip"
import "./DynamicFormPreview.css"
interface Props {
    form: DynamicFormTypes | null
    manageParentState: Function
    palette: Array<DynamicFormPaletteTypes>
    enableToolbox: boolean
    callbackKey?: string
}

interface State {
    mobile: boolean
    landscape: boolean
}

class DynamicFormPreview extends Component<Props, State> {

    state = {
        mobile: false,
        landscape: false
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    render() {

        const props = this.props
        const state = this.state
        const orientationString = state.landscape ? "portrait" : "landscape"
        const canTaskOrRelease = props.form ? props.form.CustomFormTypeId < 4 : false
        const backgroundColor = `${paletteEngine.getPaletteColor("formBackgroundColor")}`
        // const inputTextColor = `${paletteEngine.getPaletteColor("fieldInputTextColor")}`
        // const headerTextColor = `${paletteEngine.getPaletteColor("headerTextColor")}`
        
        return (
            <div className="DynamicFormPreview">
                <Modal
                    id={`dynamic-form-preview-modal-${state.mobile ? "mobile" : "desktop"}`}
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size={"lg"}
                >
                    <Modal.Header style={{ backgroundColor: !state.mobile ? backgroundColor : "unset" }}>
                        <div className="DynamicFormPreviewModalHeader">
                            <div className="DynamicFormPreviewModalHeaderLeft">
                                <span className="material-icons">dynamic_feed</span>
                                <p>{props.form?.Name}</p>
                            </div>
                            <div className="DynamicFormPreviewModalHeaderRight">
                                <OverlayTrigger placement="bottom" overlay={dynamicFormTootip("Toggle device type")}>
                                    <div className={`DynamicFormPreviewModalHeaderPreviewTypeItem ${!state.mobile ? "DynamicFormPreviewModalHeaderPreviewTypeItemActive" : ""}`}
                                        onClick={() => this.manageState([{ key: "mobile" }, { key: "landscape", value: false }])}
                                    >
                                        <span className="material-icons">computer</span>
                                    </div>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={dynamicFormTootip("Toggle device type")}>
                                    <div className={`DynamicFormPreviewModalHeaderPreviewTypeItem ${state.mobile ? "DynamicFormPreviewModalHeaderPreviewTypeItemActive" : ""}`}
                                        onClick={() => this.manageState([{ key: "mobile" }])}
                                    >
                                        <span className="material-icons">phone_android</span>
                                    </div>
                                </OverlayTrigger>
                                {state.mobile && <OverlayTrigger placement="bottom" overlay={dynamicFormTootip(`view ${orientationString}`)}>
                                    <div className="DynamicFormPreviewModalHeaderPreviewTypeItem"
                                        onClick={() => this.manageState([{ key: "landscape" }])}
                                    >
                                        <span id={`dynamic-form-preview-orientation-toggle-${orientationString}`} className="material-icons">screen_rotation</span>
                                    </div>
                                </OverlayTrigger>}
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body style={{ backgroundColor: !state.mobile ? backgroundColor : "unset" }}>
                        <div className="DynamicFormPreviewModalBody">
                            {!state.mobile && <div className="DynamicFormPreviewModalBodyDesktop">
                                <DynamicForm
                                    //@ts-ignore
                                    form={props.form}
                                    addOrRemoveColumn={() => null}
                                    palette={props.palette}
                                />
                            </div>}
                            {state.mobile && <div className={`DynamicFormPreviewModalBodyMobile ${state.landscape ? "DynamicFormPreviewModalBodyMobileLandscape" : "DynamicFormPreviewModalBodyMobilePortate"}`}>
                                <div id="d-form-prev-note-8" className="marvel-device note8">
                                    <div id="d-form-prev-inner" className="inner"></div>
                                    <div id="d-form-prev-overflow" className="overflow">
                                        <div id="d-form-prev-shadow" className="shadow"></div>
                                    </div>
                                    <div id="d-form-prev-speaker" className="speaker"></div>
                                    <div id="d-form-prev-sensors" className="sensors"></div>
                                    <div id="d-form-prev-more-sensors" className="more-sensors"></div>
                                    <div id="d-form-prev-sleep" className="sleep"></div>
                                    <div id="d-form-prev-volume" className="volume"></div>
                                    <div id="d-form-prev-camera" className="camera"></div>
                                    <div id="d-form-prev-screen" className="screen" style={{ backgroundColor: `${paletteEngine.getPaletteColor("formBackgroundColor")}` }}>
                                        <DynamicForm
                                            //@ts-ignore
                                            form={props.form}
                                            addOrRemoveColumn={() => null}
                                            palette={props.palette}
                                        />
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ backgroundColor: !state.mobile ? backgroundColor : "unset" }}>
                        <div className="DynamicFormPreviewModalFooter">
                            <Button
                                id="dynamic-form-preview-modal-footer-back-btn"
                                variant="secondary"
                                onClick={() => props.manageParentState([{ key: `${props.callbackKey ? props.callbackKey : "formToPreview"}`, value: false }])}>
                                Back
                            </Button>
                            {props.enableToolbox && <div className="DynamicFormPreviewModalFooterToolbox">
                                {canTaskOrRelease && <OverlayTrigger placement="top" overlay={dynamicFormTootip("Release form")}>
                                    <span id="dynamic-form-preview-modal-footer-release-btn" className="material-icons"
                                        onClick={() => props.manageParentState([{ key: "formToPreview", value: null }, { key: "formToRelease", value: props.form }])}>new_releases</span>
                                </OverlayTrigger>}
                                {canTaskOrRelease && <OverlayTrigger placement="top" overlay={dynamicFormTootip("Task form")}>
                                    <span id="dynamic-form-preview-modal-footer-task-btn" className="material-icons"
                                        onClick={() => props.manageParentState([{ key: "formToPreview", value: null }, { key: "formToTask", value: props.form }])}>task</span>
                                </OverlayTrigger>}
                                <OverlayTrigger placement="top" overlay={dynamicFormTootip("Delete form")}>
                                    <div id="dynamic-form-preview-modal-footer-delete-btn">
                                        <TrashCan
                                            clickCallback={() => props.manageParentState([{ key: "formToPreview", value: null }, { key: "formToDelete", value: props.form }])}
                                            color={"#dc3545"}
                                        />
                                    </div>
                                </OverlayTrigger>
                                <OverlayTrigger placement="top" overlay={dynamicFormTootip("Edit form")}>
                                    <span id="dynamic-form-preview-modal-footer-edit-btn" className="material-icons"
                                        onClick={() => props.manageParentState([{ key: "formToPreview", value: null }, { key: "formToEdit", value: props.form }])}>mode_edit</span>
                                </OverlayTrigger>
                            </div>}
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default DynamicFormPreview